<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      description: ""
    };
  },
  computed: {
    ...mapState("newOrder", ["additional_informations"])
  },
  methods: {
    ...mapActions("newOrder", ["setAdditionalInformations"]),

    cantSave() {
      return !this.description.length;
    },

    save() {
      if (this.cantSave()) {
        this.$toasted.error("Você deve escrever as instruções!");
        return;
      }

      this.setAdditionalInformations(this.description);
      this.$emit("saved");
    }
  },
  watch: {
    additional_informations(additionalInformations) {
      this.description = additionalInformations;
    }
  },

  mounted() {
    this.description = this.additional_informations;
  }
};
</script>

<template>
  <div>
    <textarea
      v-model="description"
      placeholder="Escreva instruções e cuidados para a limpeza, ou qualquer informação que achar necessária..."
      cols="55"
      rows="7"
    ></textarea>
    <div
      class="btn bg-pink mt-10"
      :class="{'btn-disabled': cantSave()}"
      @click="save()"
    >salvar e avançar</div>
  </div>
</template>

<style scoped>
div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

textarea {
  max-width: 80%;
  border-color: #ddd;
}

.btn-disabled {
  pointer-events: all !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/CheckoutPopup/Description.vue